import _typeof from "/app/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import { request } from "@/js/http/http_request";
import { getClientAppData } from "@/js/http/auth";
import { getTokens } from "@/js/consent";
import { cleanErrors, noErrors, filterVAutocomplete, getErrorData } from "@/js/forms.js";
import { regExpMail, regExpPassword, regExpPhone } from "@/js/regexp_validation.js";
import { tenantType } from "@/js/lists.ts";
import { COUNTRY_SPECIAL_WORDINGS } from "@/js/user/user";
import { fetchAddressSuggestions, parseAddressFromMapbox, getCurrentPositionAddress } from "@/js/mapbox/geocoding.js";
import BackgroundVideo from "@/components/default/BackgroundVideo.vue";
export default {
  name: "Subscribe",
  components: {
    BackgroundVideo: BackgroundVideo
  },
  data: function data() {
    return {
      clientAppData: null,
      tenantType: tenantType,
      errorLabels: {
        email: "",
        password: "",
        passwordconfirm: "",
        name: "",
        nickname: "",
        phone: "",
        street: "",
        city: "",
        country: "",
        state: "",
        company_name: "",
        vat_code: "",
        excise_code: "",
        billingEmail: "",
        certify_legal_age: ""
      },
      infosLabels: {
        country: ""
      },
      errorMessages: {
        empty: "This field is required",
        email: {
          format: "Incorrect format, valid email address expected",
          exist: "This email address already exists on the platform. If you can't sign in, it probably means that your subscription has not been reviewed yet. Please contact us for more details."
        },
        password: {
          tooeasy: "Your password must be at least 8 characters, with at least a number, an upper and lower case letter",
          unknown: "Incorrect credentials"
        },
        passwordconfirm: {
          nomatch: "Passwords do not match"
        },
        phone: {
          format: "Incorrect format, valid phone number expected"
        },
        certify_legal_age: {
          notChecked: "You must be of legal age to register on this site"
        }
      },
      infosMessages: {
        country: {
          notAvailable: "Contact us if your delivery country is not yet available"
        }
      },
      isShowPassword: false,
      input: {
        email: "",
        password: "",
        passwordconfirm: "",
        name: "",
        nickname: "",
        phone: "",
        street: "",
        address_line_2: "",
        address_line_3: "",
        address_complement: "",
        country: "",
        state: "",
        city: "",
        zipcode: "",
        company_name: "",
        vat_code: "",
        excise_code: "",
        individualCode: "",
        sponsorship_code: "",
        certify_legal_age: false,
        billingEmail: "",
        utm_source: null
      },
      step: 1,
      user_group: null,
      accountTypes: [],
      tenant_type: "",
      managedExceptions: {
        error: {
          sponsorshipcode_not_compatible_individual: "The keypass is not valid for individual customers",
          sponsorshipcode_not_compatible_country: "This keypass is not valid for this delivery country"
        },
        warning: {
          sponsorshipcode_unknown: "The keypass is not valid. Please verify it",
          create_user_exists: "This account already exists"
        }
      },
      listCountries: null,
      listStates: null,
      addressSuggestions: [],
      loadingAddressSuggestions: false,
      searchInput: null,
      debounceTimer: null,
      loadingCurrentLocation: false
    };
  },
  computed: {
    countryHasStates: function countryHasStates() {
      var _this2 = this;
      return this.input.country && this.listStates.filter(function (x) {
        return x.id_country === _this2.input.country.id_country;
      }).length > 0;
    },
    liquorNumberLabel: function liquorNumberLabel() {
      var _Object$values$find$l,
        _Object$values$find,
        _this3 = this;
      return (_Object$values$find$l = (_Object$values$find = Object.values(COUNTRY_SPECIAL_WORDINGS).find(function (x) {
        var _this3$input;
        return x.countryId == ((_this3$input = _this3.input) === null || _this3$input === void 0 || (_this3$input = _this3$input.country) === null || _this3$input === void 0 ? void 0 : _this3$input.id_country);
      })) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.liquorNumberLabel) !== null && _Object$values$find$l !== void 0 ? _Object$values$find$l : "Liquor certificate number";
    },
    taxIdLabel: function taxIdLabel() {
      var _Object$values$find$t,
        _Object$values$find2,
        _this4 = this;
      return (_Object$values$find$t = (_Object$values$find2 = Object.values(COUNTRY_SPECIAL_WORDINGS).find(function (x) {
        var _this4$input;
        return x.countryId == ((_this4$input = _this4.input) === null || _this4$input === void 0 || (_this4$input = _this4$input.country) === null || _this4$input === void 0 ? void 0 : _this4$input.id_country);
      })) === null || _Object$values$find2 === void 0 ? void 0 : _Object$values$find2.taxIdLabel) !== null && _Object$values$find$t !== void 0 ? _Object$values$find$t : "VAT/Tax number";
    },
    individualCodeLabel: function individualCodeLabel() {
      var _Object$values$find$i,
        _Object$values$find3,
        _this5 = this;
      return (_Object$values$find$i = (_Object$values$find3 = Object.values(COUNTRY_SPECIAL_WORDINGS).find(function (x) {
        var _this5$input;
        return x.countryId == ((_this5$input = _this5.input) === null || _this5$input === void 0 || (_this5$input = _this5$input.country) === null || _this5$input === void 0 ? void 0 : _this5$input.id_country);
      })) === null || _Object$values$find3 === void 0 ? void 0 : _Object$values$find3.individualCodeLabel) !== null && _Object$values$find$i !== void 0 ? _Object$values$find$i : "Legal code";
    }
  },
  created: function created() {
    var _this$$route$query, _this$$route$query2;
    if ((_this$$route$query = this.$route.query) !== null && _this$$route$query !== void 0 && _this$$route$query.utm_source) {
      this.input.utm_source = this.$route.query.utm_source;
    }
    if ((_this$$route$query2 = this.$route.query) !== null && _this$$route$query2 !== void 0 && _this$$route$query2.email) {
      this.input.email = this.$route.query.email;
    }
    this.clientAppData = getClientAppData(this);
    var _this = this;
    request("/v1/tenants/informations", "post", this.clientAppData, false, "cap").then(function (response) {
      _this.tenant_type = response.data.tenant_type;
      _this.accountTypes = [{
        id: "USER",
        name: "INDIVIDUAL"
      }, {
        id: "HORECA",
        name: "PROFESSIONAL"
      }];
    });
    request("/v1/countries?implantedMarket=true", "post", this.clientAppData, false, "api").then(function (response) {
      _this.listCountries = _toConsumableArray(response.data.countries);
      _this.listStates = _toConsumableArray(response.data.states);
    }).catch(function (err) {
      _this.$toasted.show("An error occured. Please contact an administrator.", {
        type: "error"
      });
    });
    if (this.$route.query.sponsor) {
      this.input.sponsorship_code = this.$route.query.sponsor;
    }
  },
  methods: {
    generateGUID: function generateGUID() {
      return crypto.randomUUID();
    },
    create: function create() {
      if (this.validateInputs()) {
        var _this = this;
        var data = _objectSpread({
          login: _this.input.email,
          pass: _this.input.password,
          name: _this.input.name,
          nickname: _this.input.nickname,
          phone: _this.input.phone,
          company_name: _this.input.company_name,
          vat_code: _this.input.vat_code,
          excise_code: _this.input.excise_code,
          individualCode: _this.input.individualCode,
          billingEmail: _this.input.billingEmail,
          user_group: _this.user_group,
          sponsorship_code: _this.input.sponsorship_code,
          address: {
            street: _this.input.street,
            address_line_2: _this.input.address_line_2,
            address_line_3: _this.input.address_line_3,
            address_complement: _this.input.address_complement,
            country: _this.input.country,
            state: this.countryHasStates ? _this.input.state : null,
            zip: _this.input.zipcode,
            city: _this.input.city
          },
          utm_source: _this.input.utm_source
        }, this.clientAppData);
        request("/v1/subscribe", "post", data, false, "api").then(function () {
          if (_this.tenant_type == tenantType.OWNER) {
            _this.step = 3;
          } else {
            //Auto login pabus
            var _data = {
              login: _this.input.email,
              password: _this.input.password,
              client_id: _this.clientAppData.client_id,
              client_secret: _this.clientAppData.client_secret,
              grant_type: "code",
              state: _this.generateGUID(),
              consent: true
            };
            request("/v1/gate/authorize", "post", _data, false, "cap").then(/*#__PURE__*/function () {
              var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(response) {
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      if (!(response.status == 200)) {
                        _context.next = 4;
                        break;
                      }
                      _context.next = 3;
                      return getTokens(_this, response.data.code, response.data.state, _this.clientAppData.client_id, _this.clientAppData.client_secret);
                    case 3:
                      _this.$router.push({
                        name: "accept-terms",
                        query: {
                          is_first_connection: response.data.first_connection
                        }
                      });
                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x) {
                return _ref.apply(this, arguments);
              };
            }());
          }
        }).catch(function (e) {
          if (e.response.status == 409) {
            _this.errorLabels.email = _this.errorMessages.email.exist;
          } else {
            var errorData = getErrorData(e, _this.managedExceptions);
            _this.$toasted.show(errorData.message, {
              type: errorData.type
            });
          }
        });
      }
    },
    home: function home() {
      this.$router.push({
        name: "home"
      });
    },
    selectAccountType: function selectAccountType(id, name) {
      this.user_group = id;
      this.step = 2;
      this.clearInputs(id);
    },
    clearInputs: function clearInputs(user_type) {
      if (user_type == "USER") {
        this.input.company_name = "";
        this.input.vat_code = "";
        this.input.excise_code = "";
      } else if (user_type == "HORECA") {
        this.input.individualCode = "";
      }
    },
    validateInputs: function validateInputs() {
      var _this$input$country, _this$input$country2;
      this.errorLabels = cleanErrors(this.errorLabels);
      if (this.input.email == "") {
        this.errorLabels.email = this.errorMessages.empty;
      } else if (!regExpMail.test(this.input.email)) {
        this.errorLabels.email = this.errorMessages.email.format;
      }
      if (this.input.password == "") {
        this.errorLabels.password = this.errorMessages.empty;
      }
      if (this.input.password != this.input.passwordconfirm) {
        this.errorLabels.passwordconfirm = this.errorMessages.passwordconfirm.nomatch;
      }
      if (!regExpPassword.test(this.input.password)) {
        this.errorLabels.password = this.errorMessages.password.tooeasy;
      }
      if (this.input.name == "") {
        this.errorLabels.name = this.errorMessages.empty;
      }
      if (this.input.nickname == "") {
        this.errorLabels.nickname = this.errorMessages.empty;
      }
      if (this.input.phone == "") {
        this.errorLabels.phone = this.errorMessages.empty;
      } else if (!regExpPhone.test(this.input.phone)) {
        this.errorLabels.phone = this.errorMessages.phone.format;
      }
      if (this.user_group == "HORECA" && !this.input.company_name) {
        this.errorLabels.company_name = this.errorMessages.empty;
      }
      if (this.user_group == "HORECA" && !this.input.vat_code) {
        this.errorLabels.vat_code = this.errorMessages.empty;
      }
      if (this.user_group == "HORECA" && (((_this$input$country = this.input.country) === null || _this$input$country === void 0 ? void 0 : _this$input$country.iso_code) == "USA" || ((_this$input$country2 = this.input.country) === null || _this$input$country2 === void 0 ? void 0 : _this$input$country2.iso_code) == "BRA") && !this.input.excise_code) {
        this.errorLabels.excise_code = this.errorMessages.empty;
      }
      if (!String.isNullOrEmpty(this.input.billingEmail) && !regExpMail.test(this.input.billingEmail)) {
        this.errorLabels.billingEmail = this.errorMessages.email.format;
      }
      if (!this.input.certify_legal_age) {
        this.errorLabels.certify_legal_age = this.errorMessages.certify_legal_age.notChecked;
      }
      if (!this.input.street) {
        this.errorLabels.street = this.errorMessages.empty;
      }
      if (!this.input.city) {
        this.errorLabels.city = this.errorMessages.empty;
      }
      if (!this.input.country) {
        this.errorLabels.country = this.errorMessages.empty;
      }
      if (this.countryHasStates && !this.input.state) {
        this.errorLabels.state = this.errorMessages.empty;
      }
      return noErrors(this.errorLabels);
    },
    countryNotAvailable: function countryNotAvailable() {
      !this.input.country ? this.infosLabels.country = this.infosMessages.country.notAvailable : this.infosLabels.country = "";
    },
    getStatesForSelectedCountry: function getStatesForSelectedCountry() {
      var _this6 = this;
      if (this.input.country) {
        return this.listStates.filter(function (x) {
          return x.id_country === _this6.input.country.id_country;
        });
      }
    },
    loadAddressSuggestions: function loadAddressSuggestions(query) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this7.loadingAddressSuggestions = true;
              _context2.next = 3;
              return fetchAddressSuggestions(query);
            case 3:
              _this7.addressSuggestions = _context2.sent;
              _this7.loadingAddressSuggestions = false;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    onAddressSelected: function onAddressSelected(selectedAddress) {
      var _this8 = this;
      if (typeof selectedAddress === "string") {
        this.input.street = selectedAddress;
      } else if (selectedAddress && _typeof(selectedAddress) === "object" && selectedAddress.context) {
        var addressData = parseAddressFromMapbox(selectedAddress, this.listCountries, []);
        if (addressData) {
          this.$nextTick(function () {
            _this8.input.street = addressData.street;
            if (addressData.zip) _this8.input.zipcode = addressData.zip;
            if (addressData.city) _this8.input.city = addressData.city;
            if (addressData.country) {
              _this8.input.country = addressData.country;
              _this8.$nextTick(function () {
                var addressDataWithState = parseAddressFromMapbox(selectedAddress, _this8.listCountries, _this8.getStatesForSelectedCountry());
                if (addressDataWithState && addressDataWithState.state) {
                  _this8.input.state = addressDataWithState.state;
                } else {
                  _this8.input.state = null;
                }
              });
            } else {
              _this8.input.country = null;
            }
          });
        }
      }
    },
    useCurrentLocation: function useCurrentLocation() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var currentAddress;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!_this9.loadingCurrentLocation) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              _this9.loadingCurrentLocation = true;
              _context3.prev = 3;
              _context3.next = 6;
              return getCurrentPositionAddress();
            case 6:
              currentAddress = _context3.sent;
              _this9.onAddressSelected(currentAddress);
              _context3.next = 14;
              break;
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](3);
              console.error("Error getting current location:", _context3.t0);
              _this9.$toasted.show(_context3.t0.message || "Unable to get your current location. This feature works best on mobile devices.", {
                type: "error"
              });
            case 14:
              _context3.prev = 14;
              _this9.loadingCurrentLocation = false;
              return _context3.finish(14);
            case 17:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[3, 10, 14, 17]]);
      }))();
    },
    filterVAutocomplete: filterVAutocomplete
  },
  watch: {
    searchInput: function searchInput(newVal) {
      var _this10 = this;
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(function () {
        if (newVal) {
          _this10.loadAddressSuggestions(newVal);
        }
      }, 300);
    }
  }
};